import React from 'react';

import { Button } from 'antd';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandAddProduct: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        action();
    }

    return (
        <Button
            className="command-button"
            disabled={disabled}
            type="primary"
            size={'middle'}
            onClick={_handleCommandAction}
        >
            Add Product
        </Button>
    );
}

export default CommandAddProduct;